// src/core/base-services.js
import EventManager from "../../core/event-bus";

/**
 * 直播服务抽象基类
 */
export class BaseImService {
  constructor() {
    if (new.target === BaseImService) {
      throw new Error("Cannot instantiate abstract class BaseLiveService");
    }
    this.eventManager = new EventManager();
    this.client = null;
    this.isReady = false;
    this.isLogin = false;
  }

  // 事件相关方法
  on(eventName, callback) {
    return this.eventManager.on(eventName, callback);
  }

  once(eventName, callback) {
    return this.eventManager.once(eventName, callback);
  }

  off(eventName, callback) {
    return this.eventManager.off(eventName, callback);
  }

  // 受保护的方法，供子类调用以触发事件
  _emit(eventName, data) {
    this.eventManager.emit(eventName, data);
  }
  // 其他抽象方法...
  // 二次处理消息信息
  handleChatMsg() {
    throw new Error(
      `Abstract method 'handleChatMsg' must be implemented in ${this.constructor.name}`
    );
  }
  getMessageList(params = {}) {}
  // 获取群成员资料
  getGroupMemberProfile(params) {
    throw new Error(
      `Abstract method 'getGroupMemberProfile' must be implemented in ${this.constructor.name}`
    );
  }
  // 发送消息
  sendMessage(message) {
    throw new Error(
      `Abstract method 'sendMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 发送直播间内的自定义消息
  sendMGLiveRoomCustomMsg(data) {
    throw new Error(
      `Abstract method 'sendMGLiveRoomCustomMsg' must be implemented in ${this.constructor.name}`
    );
  }
  // 创建文本消息
  createTextMessage(params) {
    throw new Error(
      `Abstract method 'createTextMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 创建图片消息
  createImageMessage(params) {
    throw new Error(
      `Abstract method 'createImageMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 创建文件消息
  createFileMessage(params) {
    throw new Error(
      `Abstract method 'createFileMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 创建自定义消息
  createCustomMessage(params) {
    throw new Error(
      `Abstract method 'createCustomMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 转换为IM消息
  convertToIMMessage(item, userInfo) {
    throw new Error(
      `Abstract method 'convertToIMMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 撤回消息
  revokeMessage(message = {}) {
    throw new Error(
      `Abstract method 'revokeMessage' must be implemented in ${this.constructor.name}`
    );
  }
  // 重新发送消息
  resendMessage(message, options = {}) {
    throw new Error(
      `Abstract method 'resendMessage' must be implemented in ${this.constructor.name}`
    );
  }
}
